export class VehicleGroupReferenceModel {
    public vehicleGroupCode: string;
    public vehicleGroupName: string;
    public sortSequence: number;
}